<template>
    <div>
        <v-container>
            <v-card :loading="loading">
                <v-card-title class="bg-blue-grey-darken-2">
                    <div class="d-flex justify-space-between">
                        <h1><v-icon icon="mdi-package-variant" class="mr-1"></v-icon> {{ taskDetails.title }} Packing</h1><h2 v-if="date">{{ date.format('DD-MM-YYYY') }} <v-chip v-if="jobs">{{ completedList.length }} / {{ jobs.length }} <v-icon icon="mdi-check-circle"></v-icon></v-chip></h2>
                    </div>
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-list lines="two">
                        <v-list-item v-for="job in orderedJobs"
                                     :key="job.id"
                                     class="p-1"
                                     :class="{'list-job':true, 'bg-light-blue-lighten-4':jobRunning(job), 'bg-teal-lighten-1': jobSprayingCompleted(job), 'job-completed':jobPacked(job)}">
                            <template v-slot:prepend>
                                <div class="prepend-job">
                                    <v-icon v-if="jobSprayingCompleted(job) && !jobPacked(job)" icon="mdi-progress-check"></v-icon>
                                    <v-icon v-if="jobRunning(job)  && !jobPacked(job)" icon="mdi-spray"></v-icon>
                                    <v-icon v-if="jobPacked(job)" icon="mdi-package-variant-closed-check"></v-icon>
                                </div>
                            </template>
                            <v-list-item-title>
                                <h3>{{ job.name }} <v-chip v-if="jobPaused(job)">PAUSED</v-chip><v-chip v-if="jobRunning(job) && !jobPacked(job)">Spraying Now</v-chip><v-chip v-if="jobSprayingCompleted(job) && !jobPacked(job)">Spraying Completed</v-chip></h3>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <div>{{ job.customerNumber }}</div>
                                <div>{{ job.contact.name }}</div>
                            </v-list-item-subtitle>
                            <template v-slot:append>
                                <div class="append-job">
                                    <v-btn variant="flat"
                                           class="mr-1 text-black"
                                           prepend-icon="mdi-package-check"
                                           @click="togglePacked(job)"
                                           v-if="jobSprayingCompleted(job) && !jobPacked(job)"
                                           style="height:55px">Mark Packed</v-btn>
                                </div>
                                <div class="append-job">
                                    <v-btn variant="flat"
                                           class="mr-1 text-black"
                                           @click="togglePacked(job)"
                                           prepend-icon="mdi-package-variant-closed-remove"
                                           v-if="jobPacked(job)"
                                           style="height:55px"> Mark Not Packed</v-btn>
                                </div>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>
<style scoped lang="scss">
    .list-job {
        border-bottom:1px solid lightgray;
    }
    .prepend-job {
        width: 25px;
    }
    .job-completed {
        background-color: #e0e0e0 !important;
        color:darkgray;
    }
    .job-paused {
        background-color: #CFD8DC !important;
    }
</style>
<script>
    import { mapActions, mapState } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false,
            date: null,
            jobs: [],
            refreshCounter: 0
        };
    }
    export default {
        name: "PackingListView",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.date = this.$dayjs();
            this.getData();
        },
        props: {
            task: String,
        },
        methods: {
            ...mapActions([
                'showErrorSnack',
                'showSuccessSnack'
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            togglePacked(job) {
                this.$api.post('/jobs/togglepacked/?id=' + job.jobTaskId)
                    .then(res => {
                        this.showSuccessSnack('Packing updated')
                        job.activeTask.packed = !job.activeTask.packed;
                    }).catch(error => {
                        this.showErrorSnack('We ran into an issue');
                        console.log(error)
                    });
            },
            getData() {
                this.loading = true;
                let dateSelector = this.date.format("YYYY-MM-DD");
                this.$api.get(`/dashboard/timetable?task=${this.task}&date=${dateSelector}`)
                    .then(res => {
                        this.jobs = res.data.jobs
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("There was an issue getting the timetables.");
                    });
            },
            jobRunning(job) {
                return job.activeTask.running;
            },
            jobSprayingCompleted(job) {
                return (job.jobStatus != this.task || job.activeTask.completed) && !job.uncomplete;
            },
            jobPaused(job) {
                return job.activeTask.paused;
            },
            jobPacked(job) {
                return job.activeTask.packed;
            }
        },
        computed: {
            taskDetails() {
                return this.$constants.tasks.types[this.task - 1];
            },
            completedList() {
                if (this.jobs) {
                    return this.jobs.filter(job => {
                        return this.jobPacked(job);
                    });
                }
                return [];
            },
            orderedJobs() {
                if (this.jobs) {
                    const jobCompF = this.jobSprayingCompleted;
                    const jobRunF = this.jobRunning;
                    const jobPackedF = this.jobPacked;

                    return this.jobs.toSorted((a, b) => {
                        // assign a sort rank to each job
                        const rank = job => {
                            if (jobCompF(job) && !jobPackedF(job)) return 1;  // completed → top
                            if (jobRunF(job) && !jobPackedF(job)) return 2;   // running → next
                            if (!jobPackedF(job)) return 3; // not packed (and not completed/running)
                            return 4;                     // packed → bottom
                        };

                        return rank(a) - rank(b);
                    });
                }
                return [];
            }
        },
        watch: {
            refreshCounter: {
                handler: function () {
                    this.getData();
                }
            }
        }
    };
</script>